// Live-view idle timeouts (ENG-1132, tightened in ENG-2149). Live view is
// metered on relay PUBLISH time, and the publisher runs as long as any player
// keeps pulling the playlist — a tab left open with nobody at the desk burns
// the customer's per-camera monthly allowance at full rate.
//
// Flow: once the stream is actually PLAYING (the clock never runs during a
// cold start), IDLE_MS with no user activity anywhere on the page shows a
// "Still watching?" prompt over the live video. If nobody confirms within
// IDLE_GRACE_MS the player is torn down (the relay's viewer-reaper then stops
// the publisher within ~30 s) and stays paused until the operator clicks
// Resume.
//
// Live view is an event-REVIEW tool (monitoring happens via event generation),
// not a standing video wall, so the window is deliberately short — and it is
// the SAME for every viewer. Staff (the mint's `cap_exempt`) and uncapped
// plans (`cap_minutes: 0`, which covers the internal "Actuate" leads as well
// as any 24/7 opt-in) used to get a 30 min window; that carve-out hid the
// prompt from every internal tester and was removed in ENG-2149. The cap
// fields still drive billing/overage, just not the idle prompt.
//
// Not configurable per build or per customer for now (ENG-2149 asked for a
// per-customer setting; revisit if a second customer wants a different value).

/** Single Live View / Split View player. */
export const LIVE_VIEW_IDLE_MS = 30 * 1000;

/** Site Video Wall (many cameras × full rate). */
export const VIDEO_WALL_IDLE_MS = 30 * 1000;

/** How long the "Still watching?" prompt waits for a click before the stream
 * is torn down. */
export const IDLE_GRACE_MS = 5 * 1000;
